import React from 'react'
//import _ from 'lodash'

// import { logout, fbLogin } from '../../redux/user/actions'
// import store from '../redux/user/store'

class Link extends React.Component {  
  onClick (href, event) {
    if (this.props.onClickMiddleware) {
      this.props.onClickMiddleware(href, event, this.onClickNext.bind(this, href, event))
    } else {
      this.onClickNext(href, event)
    }
  }

  onClickNext (href, event) {
    // if (_.includes(['/logout', '/sign-out'], href)) {
    //   store.dispatch(logout())
    // } else if (_.includes(['/fb-login', '/fb-sign-in', '/fb-sign-up', '/fb-register'], href)) {
    //   store.dispatch(fbLogin())
    // } else {
    //   return
    // }
    // event.preventDefault()
  }
  
  render () {
    var props = { ...this.props }
    delete props.onClickMiddleware
    return (
      <a onClick={this.onClick.bind(this, this.props.href)} {...props}>{this.props.children}</a>
    )
  }
}

export default Link